import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';

export const ListItemContainer = styled(Stack)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
`;

export const Description = styled(Stack)`
  margin-bottom: ${tokens.spacer.x6};
`;

export const ListItemTitleWrapper = styled(Stack)`
  width: 100%;
`;

export const ListItemText = styled.span`
  flex: 1;
`;

export const ListItemTitle = styled(Stack)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ListItemHeader = styled(Stack)`
  justify-content: space-between;
`;
